import { isEmpty } from 'lodash';

class HtmlPageService {
  private head = document.getElementsByTagName('head')[0];

  public setFavicon(src: string) {
    if (!src) {
      return;
    }
    let link: HTMLLinkElement = this.head.querySelector(
      'link[rel="shortcut icon"]'
    );
    if (!link) {
      link = document.createElement('link');
      link.rel = 'shortcut icon';
      this.head.appendChild(link);
    }
    link.href = src;
  }

  public setTitle(title: string) {
    if (isEmpty(title?.trim())) {
      return;
    }
    const titleElement = this.head.getElementsByTagName('title');
    if (isEmpty(titleElement)) {
      this.head.appendChild(document.createElement('title'));
    }
    titleElement[0].text = title;
  }
}

export default new HtmlPageService();
